/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WindowsTimezone } from './WindowsTimezone';
import {
    WindowsTimezoneFromJSON,
    WindowsTimezoneFromJSONTyped,
    WindowsTimezoneToJSON,
    WindowsTimezoneToJSONTyped,
} from './WindowsTimezone';

/**
 * 
 * @export
 * @interface TimezoneListEntry
 */
export interface TimezoneListEntry {
    /**
     * 
     * @type {WindowsTimezone}
     * @memberof TimezoneListEntry
     */
    timezone: WindowsTimezone;
    /**
     * 
     * @type {string}
     * @memberof TimezoneListEntry
     */
    description: string;
}



/**
 * Check if a given object implements the TimezoneListEntry interface.
 */
export function instanceOfTimezoneListEntry(value: object): value is TimezoneListEntry {
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function TimezoneListEntryFromJSON(json: any): TimezoneListEntry {
    return TimezoneListEntryFromJSONTyped(json, false);
}

export function TimezoneListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimezoneListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'timezone': WindowsTimezoneFromJSON(json['timezone']),
        'description': json['description'],
    };
}

export function TimezoneListEntryToJSON(json: any): TimezoneListEntry {
    return TimezoneListEntryToJSONTyped(json, false);
}

export function TimezoneListEntryToJSONTyped(value?: TimezoneListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timezone': WindowsTimezoneToJSON(value['timezone']),
        'description': value['description'],
    };
}

